<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MaintainReport/StockPending'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3">
                <div class="form-group ">
                  <label class="label">วันที่ประเมิน(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">วันที่ประเมิน(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>BARCODE :</label>
                  <input v-model="qiOldBarcode" type="text" class="form-control" placeholder="BARCODE"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>เลขที่ใบงาน :</label>
                  <input v-model="qiJobNumber" type="text" class="form-control" placeholder="เลขที่ใบงาน"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ประเภทสินค้า:</label>
                  <treeselect id="qiProductType" v-model="qiProductType" :multiple="true" :options="qiProductTypeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">แบรนด์สินค้า:</label>
                  <treeselect id="qiProductBrand" v-model="qiProductBrand" :multiple="true" :options="qiProductBrandOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">สถานะ:</label>
                  <treeselect id="qiEvalStatus" v-model="qiEvalStatus" :multiple="true" :options="qiEvalStatusOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right" v-if="this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN'])">
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped table-bordered table-hover table-checkable"
                id="reportTable" style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all">ประเภทสินค้า</th>
                    <th class="all">รหัสสินค้า</th>
                    <th class="all">ชื่อสินค้า</th>
                    <th class="all">แบรนด์</th>
                    <th class="all">BARCODE</th>
                    <th class="all">จำนวน</th>
                    <th class="all">ซ่อมเสร็จ/ทำลาย</th>
                    <th class="all">คงเหลือ</th>
                    <th class="all">วันที่ประเมิน</th>
                    <th class="all">อาการเสีย</th>
                    <th class="all">เลขที่ใบงาน</th>
                    <th class="all">สถานะ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
import Collapsible from "../../Shared/Collapsible";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      qiProductType: null,
      qiProductBrand: null,
      qiEvalStatus: null,
      qiProductCodeOptions: [],
      qiProductTypeOptions: [],
      qiProductBrandOptions: [],
      qiEvalStatusOptions: [],
      qiOldBarcode: null,
      qiJobNumber: null,
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      const startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      const today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiProductCode = null;
      this.qiProductType = null;
      this.qiProductBrand = null;
      this.qiEvalStatus = null;
      this.qiOldBarcode = null;
      this.qiJobNumber = null;

      $(`#qiProductCode`).val("").trigger("change");
      $(`#qiProductType`).val("").trigger("change");
      $(`#qiProductBrand`).val("").trigger("change");
      $(`#qiEvalStatus`).val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');

      // this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ExportStockPending",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIProductType: self.qiProductType,
          QIProductBrand: self.qiProductBrand,
          QIEvalStatus: self.qiEvalStatus,
          Barcode: self.qiOldBarcode,
          QIJobNumber: self.qiJobNumber,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiSpare', 'QiMachine', 'QiEquipment'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreQIProductTypeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/QIJobs/SubProductType")
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductTypeOptions = [];
            data.forEach((element) => {
              self.qiProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreQIProductBrandOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductBrandOptions = [];
            data.forEach((element) => {
              self.qiProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreEvalStatusOptions: function (e) {
      var self = this;
      self.qiEvalStatusOptions = [];
      var data = [
        {
          id: "StatusRepair",
          text: "รอซ่อม",
        },
        {
          id: "StatusMaintain",
          text: "รอบำรุงรักษา",
        },
        {
          id: "StatusDestroy",
          text: "รอทำลาย",
        },
        {
          id: "StatusRepairSupplier",
          text: "ส่งซ่อมซัพพลายเออร์",
        },
      ];
      data.forEach((element) => {
        self.qiEvalStatusOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
  },
  async mounted() {
    let self = this;
    self.LoadreProductCodeOptions();
    self.LoadreQIProductTypeOptions();
    self.LoadreQIProductBrandOptions();
    self.LoadreEvalStatusOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    const today = moment();
    const startOfMonth = moment().startOf('month');
    self.jobsDateStart = startOfMonth;
    self.jobsDateEnd = today;

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    }).datepicker('setDate', startOfMonth.toDate());
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    }).datepicker('setDate', today.toDate());
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#reportTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/StockPending",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
              EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
              QIProductCode: self.qiProductCode,
              QIProductType: self.qiProductType,
              QIProductBrand: self.qiProductBrand,
              QIEvalStatus: self.qiEvalStatus,
              Barcode: self.qiOldBarcode,
              QIJobNumber: self.qiJobNumber,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [30, 50, 100],
        pageLength: 30,
        language: {lengthMenu: "Display _MENU_",},
        order: [[7, "asc"]],
        ordering: false,
        columns: [
          {
            data: "subProductTypeName", className: "text-center",
                render: function (data, type, full, meta) {
                return data ? data : '-';
            }
          },
          {
            data: "materialCode", className: "text-center",
              render: function (data, type, full, meta) {
                  return data ? data : '-';
            }
          },
          {
            data: "materialName", className: "text-center",
              render: function (data, type, full, meta) {
                return data ? data : '-';
            }
          },
          {
            data: "productBrandName", className: "text-center",
              render: function (data, type, full, meta) {
                  if (!data || data.trim() === '') {
                      return '-';
                  }
                  return data;
            }
          },
          {
            data: "barcodeNoOld",
            className: "text-center",
            render: function (data, type, row) {
              return data && data.trim() ? data : "ไม่มี BARCODE";
            }
          },
            {
                data: "amountToProcess", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
            },
            {
                data: "completedAmount", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
            },
            {
                data: "remainingAmount", className: "text-center",
                render: function (data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                }
            },
          {
            data: "finishedDate",
            className: "text-center",
            render: function (data, type, row) {
              if (!data || data === "0001-01-01T00:00:00") return "-";
              return moment(data).format("DD/MM/YYYY");
            },
          },
          {
            data: "evalRemark",
            className: "text-center",
              render: function (data, type, full, meta) {
                  if (!data || data.trim() === '') {
                      return '-';
                  }
                  return data;
            }
          },
          {
            data: "qiJobNumber",
            className: "text-center",
            render: function (data, type, full, meta) {
                return data ? data : '-';
            }
          },
          {
            data: "evalFlag",
            className: "text-center",
            render: function (data, type, row) {
              switch (data) {
                case 1:
                  return "รอทำลาย";
                case 2:
                  return "รอซ่อม";
                case 3:
                  return "รอบำรุงรักษา";
                case 4:
                  return "ส่งซ่อมซัพพลายเออร์";
                default:
                  return "-";
              }
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/QIJob/ReportStockPending.vue